module.exports = __webpack_public_path__ + "img/logo-sm.34bc8b33.png";